import alertReducer from './alertReducer';

export default alertReducer;
